import { faObjectGroup } from '@fortawesome/free-solid-svg-icons';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import React from 'react';
import { Spinner } from 'react-bootstrap';

/**
 * Materials button component that displays a badge counter
 * for the number of unique stocks assigned
 */
const MaterialsButton = ({ count, onClick, className, hasWarning, isLoading }) => {
  if (!count || count === 0) {
    return null;
  }

  if (isLoading) return <Spinner animation='grow' />;

  return (
    <button
      type='button'
      className={`materials-button ${className || ''}`}
      aria-label={`View ${count} stock material${count !== 1 ? 's' : ''}`}
      onClick={onClick}
    >
      <FontAwesomeIcon icon={faObjectGroup} className='materials-icon' />
      {count > 0 && <span className='materials-badge'>{count}</span>}
      {hasWarning && (
        <FontAwesomeIcon
          icon={faExclamationTriangle}
          className='materials-warning-icon'
          title='Some pieces have individual stock assignments'
        />
      )}
    </button>
  );
};

MaterialsButton.propTypes = {
  count: PropTypes.number.isRequired,
  onClick: PropTypes.func.isRequired,
  className: PropTypes.string,
  hasWarning: PropTypes.bool,
  isLoading: PropTypes.bool,
};

MaterialsButton.defaultProps = {
  className: '',
  hasWarning: false,
  isLoading: false,
};

export default MaterialsButton;
